import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { BonusService } from "src/app/services/bonus/bonus.service";
import { GlobalErrorHandlerService } from "src/app/services/global-errors/global-error-handler.service";
import { Navigator } from 'src/app/components/menu/navigator';
import { IBonusCodeMessage } from "src/app/interfaces/player-dashboard.interface";
import { ConfigService } from "src/app/services/config/config.service";

@Component({
    selector: 'app-bonus-section',
    templateUrl: './bonus-section.component.html',
    styleUrls: ['./bonus-section.component.scss'],
})
export class BonusSectionComponent {
    public redeemForm = new FormGroup(
        {
            bonus_code: new FormControl('', [Validators.required]),
        }
    );
    public message: IBonusCodeMessage | null; 

    constructor (
        private bonusService: BonusService,
        private globalErrorHandler: GlobalErrorHandlerService,
        private navigator: Navigator,
        private configService: ConfigService,
    ) {}

    public onSubmit() {
        this.message = null;
        const bonusCodeCtrl = this.redeemForm.get("bonus_code")
        this.bonusService.callValidateBonus(bonusCodeCtrl.value).subscribe({
          next: (response: any) => {
            if (response?.result === 1) {
                this.navigator.openPopover(
                    'BonusCheckPopoverComponent',
                    {
                        headerCloseButton: true,
                        headerText: this.configService.getConfig().FEATURE_BONUS_CHECK_DIALOG_VALID_TITLE || 'Bonus available for claim',
                        message: this.configService.getConfig().FEATURE_BONUS_CHECK_DIALOG_VALID_TEXT || 'Redeem this bonus and it will be added to your bonus offers.',
                        buttonText: this.configService.getConfig().FEATURE_BONUS_CHECK_DIALOG_VALID_BUTTON_TEXT || 'Claim',
                        buttonActionExtend: () => this.navigator.navigateTo('RedeemBonusCodeComponent', {}, {  bonusCode: bonusCodeCtrl.value })
                    },
                    'standard-popover',
                    true,
                    true,
                    true
                );
            }
          },
            error: (error) => {
                console.error(error);
                this.navigator.openPopover(
                    'BonusCheckPopoverComponent',
                    {
                        headerText: this.configService.getConfig().FEATURE_BONUS_CHECK_DIALOG_INVALID_TITLE || 'Bonus code not found',
                        message: this.configService.getConfig().FEATURE_BONUS_CHECK_DIALOG_INVALID_TEXT || 'No bonuses available with that code',
                        buttonText: this.configService.getConfig().FEATURE_BONUS_CHECK_DIALOG_INVALID_BUTTON_TEXT || 'Close',
                    },
                    'standard-popover',
                    true,
                    true,
                    true
                );
            }
        });
    }

    public openRedeemBonusCodePage() {
        this.navigator.navigateTo('RedeemBonusCodeComponent');
    }

    public resetMessage() {
        this.message = null;
    }
}